exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";.inline-edit{display:inline-block;height:1.5em}.inline-edit input{font-size:1em;width:10vw}.inline-edit span{vertical-align:middle}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/InlineEdit/InlineEdit.scss
 ** module id = 748
 ** module chunks = 0
 **/